<section class="relative flex h-full flex-col overflow-hidden">
  <p-button icon="true"
            class="absolute top-[0.75rem] right-[0.75rem]"
            severity="contrast"
            rounded="true"
            styleClass="!size-[1.75rem] !px-0 !py-0"
            [text]="true"
            (click)="close()">
    <svg-icon src="icons/icon-close-popup.svg" name="icon-close-popup" svgClass="!text-(--p-primary-200)"></svg-icon>
  </p-button>

  <div class="flex shrink-0 flex-col gap-[0.25rem] px-5 pr-10 pt-[1.5rem]">
    <span class="text-[1rem] font-semibold leading-[150%] text-(--p-primary-500)">
      {{ '@@leak-detection-context-menu-sound-signal-recording-start-times__label' | translate }}
    </span>
    <span class="text-[0.875rem] text-(--p-primary-500)"
          translate="@@shared-logger__serial-number"
          [translateParams]="{ I18N_VAR_SERIAL: serialNo() }"></span>
  </div>

  <div class="relative my-4 flex-1 overflow-auto px-5">
    @if (loading()) {
      <gc-spinner></gc-spinner>
    } @else if (rows().length) {
      <div class="flex flex-col gap-[0.5rem]">
        @for (row of rows(); track row.index) {
          <div class="flex h-[2.5rem] shrink-0 items-center justify-between rounded-[0.5rem] border border-(--p-primary-50) bg-white px-[1rem]">
            <span class="text-[0.75rem] font-medium text-(--p-primary-500)">
              {{ '@@dialog-sound-signal-recording-start-times-row__label' | translate: { I18N_VAR_INDEX: row.index } }}
            </span>

            <div class="flex items-center gap-[0.5rem]">
              <span class="text-[0.75rem] text-(--p-gray-950)">{{ row.date }}</span>
              <span class="h-[1rem] w-px bg-(--p-gray-300)"></span>
              <span class="text-[0.75rem] text-(--p-gray-950)">{{ row.time }}@if (row.milliseconds) {<span *ngxPermissionsOnly="[PermissionName.LeakDetection_Read_DeveloperColumns]">.{{ row.milliseconds }}</span>}</span>
              <span class="h-[1rem] w-px bg-(--p-gray-300)"></span>
              <div class="cursor-pointer"
                   type="button"
                   tabindex="0"
                   (keydown.enter)="soundSignalService.download(row.url, row.id)"
                   (keydown.space)="soundSignalService.download(row.url, row.id)"
                   (click)="soundSignalService.download(row.url, row.id)">
                <svg-icon src="icons/icon-download.svg" name="icon-download" class="size-[1.25rem] flex shrink-0" svgClass="!text-(--p-primary-500)"></svg-icon>
              </div>
            </div>
          </div>
        }
      </div>
    } @else {
      <div class="flex h-full items-center justify-center">
        <gc-error-message iconSrc="icons/icon-no-recording-data.svg" iconName="icon-no-recording-data" iconSize="5rem">
          <div translate="@@dialog-sound-signal-recording-start-times-empty__text"></div>
        </gc-error-message>
      </div>
    }
  </div>

  <div class="flex shrink-0 items-center justify-end gap-1 px-5 pb-4">
    <p-button [label]="'@@shared-close' | translate"
              variant="outlined"
              severity="secondary"
              styleClass="h-[2rem] !px-[0.95rem] hover:!bg-(--p-neutral-500) hover:!text-(--p-primary-600) hover:!border-(--p-primary-600)"
              (onClick)="close()" />
  </div>
</section>
